export default "__VITE_ASSET__Ck$1Axp4__"